'use strict';

/**
 * All JS for any action of the Jobs on the server side
 */
waApp.controllers.Jobs = {
	_addAndEdit: function() {
		waUtils.initCkEditor({
			toolbar: 'Jobs',
			removePlugins: 'elementspath'
		});

		$('#location-same-as-office-address').on('change', function(event) {
			let value = $(this).val();

			if (value == 1) {
				$('.float-label-control:has(#city)').hide();
				$('.float-label-control:has(#country-id)').hide();
				$('#city').prop('required', false);
				$('#country-id').prop('required', false);
			} else {
				$('.float-label-control:has(#city)').show();
				$('.float-label-control:has(#country-id)').show();
				$('#city').prop('required', true);
				$('#country-id').prop('required', true);
			}
		});

		$('#location-same-as-office-address').trigger('change');

		$('#preview-button').on('click', function(event) {
			event.preventDefault();

			for (let instance in CKEDITOR.instances) {
				CKEDITOR.instances[instance].updateElement();
			}

			let language = waApp.getLanguage();
			let formData = $('#job-form').serialize();

			$.post('/' + language + '/jobs/preview', formData)
				.done(function(data) {
					$('#job-form-container').hide();
					$('#preview').html(data);
					$('#preview').show();
					$('html,body').scrollTop(0);
				});
		});

		$('#preview').on('click', '#preview-back-button', function(event) {
			event.preventDefault();

			$('#preview').hide();
			$('#job-form-container').show();
		});
	},
	add: function() {
		waApp.controllers.Jobs._addAndEdit();
	},
	edit: function() {
		waApp.controllers.Jobs._addAndEdit();
	},
	buyCredits: function() {
		$('#invoice-address').change(function(e) {
			e.preventDefault();
			let _this = $(this);
			let branchId = _this.val();
			if (branchId == undefined || branchId == '') {
				$('#package-id').empty();
				$('#payment-method').empty();
				return;
			}
			$.get('/jobs/packages/' + branchId + '.json', function(data, textStatus, jqXHR) {
				$('#package-id').empty();
				for (let key in data.jobPackages) {
					let value = data.jobPackages[key];
					$('#package-id').append($('<option>').text(value).attr('value', key));
				}
			});
			$.get('/jobs/payment-methods/' + branchId + '.json', function(data, textStatus, jqXHR) {
				$('#payment-method').empty();
				for (let key in data.paymentMethods) {
					let value = data.paymentMethods[key];
					$('#payment-method').append($('<option>').text(value).attr('value', key));
				}
			});
		});
		$('#invoice-address').trigger('change');
	}
};
